import React, { useContext, useEffect, useState } from 'react';
import {
  IonAlert,
  IonButton,
  IonButtons,
  IonCheckbox,
  IonCol,
  IonContent,
  IonPage,
  IonFooter,
  IonGrid,
  IonHeader,
  IonList,
  IonModal,
  IonTextarea,
  IonToolbar,
  IonTitle,
  IonInput,
  IonLabel,
  IonItem,
  IonRow,
  IonLoading,
  IonToast, IonSelectOption, IonSelect,
} from '@ionic/react';
import {storeProperties, storeSelfEmployedUserProperties} from '../utilities/ApiTasks';
import {getUserAssociatedProperties} from '../utilities/Storage';
import { addUpdate } from '../utilities/Updates';
import moment from 'moment';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ApiContext } from '../contexts/ApiContext';
import { useAuthentication } from '../authentication/authentication-hook';
import {getAssignedSupplierId, userIsSelfEmployed} from "../dataStructures/user/predicates";
import {Toolbar} from "./Toolbar";

export default function NewJob() {
  const { dataInitialised } = useContext(ApiContext);

  const history = useHistory();
  const [properties, setProperties] = useState();
  const [propertySearch, setPropertySearch] = useState();
  const [propertySearchResult, setPropertySearchResult] = useState([]);
  const [property, setProperty] = useState();
  const [notes, setNotes] = useState('');
  const [jobType, setJobType] = useState('maintenance_job_in_review');
  const [alert, setAlert] = useState(false);
  const [propertySelectModal, setPropertySelectModal] = useState(false);
  const [startJobNow, setStartJobNow] = useState(false);
  const [errorToast, setErrorToast] = useState(false);
  const [errorToastMessage, setErrorToastMessage] = useState('');

  const { user } = useAuthentication();

  const isSelfEmployed = userIsSelfEmployed(user);

  const togglePropertySelectModal = () => {
    setPropertySelectModal(!propertySelectModal);
  }

  useEffect(() => {
    const getData = async () => {
      isSelfEmployed ? await storeSelfEmployedUserProperties() : await storeProperties();
      setProperties(await getUserAssociatedProperties());
    }

    if(dataInitialised) {
       getData();
    }
  }, [dataInitialised]);

  const doSearch = (term) => {
    const lower = term.toLowerCase();
    const results = [];

    for (const property of properties) {
      if (property.tabspropref.toLowerCase().includes(lower) ||
          property.name.toLowerCase().includes(lower)) {

        results.push(property);
      }
    }

    setPropertySearchResult(results);
  }

  useEffect(() => {
    if (propertySearch && propertySearch.length >= 3) {
      doSearch(propertySearch);
    }
  }, [propertySearch]);


  const showError = error => {
    setErrorToastMessage(error);
    setErrorToast(true);
  }

  const create = async () => {
    if (!property?.id) {
      setAlert(true);
      showError('Please select a property.');
      return false;
    }

    if (!notes) {
      setAlert(true);
      showError('The notes field is mandatory.');
      return false;
    }

    setAlert(false);
    const user = JSON.parse(localStorage.apiuser);

    let shortdescription = `${user.title} ${user.firstname} ${user.surname} has raised a job.`;
    if(jobType === "housekeeping_job_in_review") {
      shortdescription = shortdescription.replace('job', 'cleaning job');
    }

    const obj = {
      type: 'Instance',
      propertyid: property.id,
      rating: 'low',
      shortdescription: shortdescription,
      fulldescription: notes,
      invoiceto: 'None',
      accesscontacttype: 'N/A',
      supplierid: await getAssignedSupplierId(isSelfEmployed, jobType, user.id),
      substatus: jobType
    }

    if(jobType === "maintenance_job_in_review") {
      obj.workordersourceid = 1;
    } else {
      obj.coverclean = 1;
    }

    if (startJobNow) {
      obj.preferredstartdatetime = moment().format('YYYY-MM-DD HH:mm:ss');
      obj.durationminutes = 60;
    }

    await addUpdate('create_job', {obj});

    setAlert(true);
  }

  return (
    <IonPage>
      <IonHeader>
        <Toolbar title="New Job" backButtonHref="/" />

        <IonToolbar color="light" className="ion-padding-start ion-padding-end">
          Choose a property and enter notes for why you believe this job is required.<br /><br />
          Property Management will review this information and schedule the job as necessary. <br /><br />
          If this is an urgent request, please call the office. <br />
        </IonToolbar>
      </IonHeader>
      <IonContent>
        {dataInitialised ? (
          <>
            <IonItem>
              <IonLabel position="floating">Enter at least 3 characters of the property name/reference</IonLabel>
              <IonInput clearInput value={propertySearch} onIonChange={e => setPropertySearch(e.detail.value)} />
            </IonItem>
            <IonItem button={true} onClick={togglePropertySelectModal} disabled={propertySearchResult.length === 0}>
              <IonLabel>{propertySearchResult.length} result(s)</IonLabel>
            </IonItem>
            {property &&
            <IonItem>
              <IonLabel>
                property
                <p>{property.tabspropref} - {property.name}</p>
              </IonLabel>
            </IonItem>
            }
            <IonItem>
              <IonLabel position="stacked">
                Job Type
              </IonLabel>
              <IonSelect value={jobType} onIonChange={e => setJobType(e.target.value)}>
                <IonSelectOption value="housekeeping_job_in_review">
                  Housekeeping
                </IonSelectOption>
                <IonSelectOption value="maintenance_job_in_review">
                  Maintenance
                </IonSelectOption>
              </IonSelect>
            </IonItem>
            <IonItem>
              <IonLabel position="stacked" value={notes}>
                Notes
              </IonLabel>
              <IonTextarea autoGrow={true} onIonChange={e => setNotes(e.target.value)} />
            </IonItem>
            { !isSelfEmployed && jobType === 'maintenance_job_in_review' &&
              <IonItem>
                <IonLabel>start job now</IonLabel>
                <IonCheckbox
                  slot="end"
                  checked={startJobNow}
                  onIonChange={e => setStartJobNow(e.target.checked)}
                />
              </IonItem>
            }
          </>
        ) : (
          <IonLoading
            isOpen={true}
            message="Loading..."
            spinner="crescent"
          />
        )}
      </IonContent>
      <IonFooter no-border>
        <IonToolbar className="ion-text-center">
          <IonGrid>
            <IonRow>
              <IonCol>
                <IonButton
                  color="medium"
                  expand="block"
                  disabled={!property || notes.length === 0}
                  onClick={create}
                >
                  create job
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonToolbar>
      </IonFooter>
      <IonAlert
        isOpen={alert}
        onDidDismiss={() => { setAlert(false); history.goBack(); }}
        header={'Job submitted'}
        message={
          startJobNow ?
          'Your job has been requested and will be available in the day plan shortly.' :
          'Thank you for your request. The office team will review and action it shortly. If this is an urgent request, please call the office.'}
        buttons={['OK']}
      />

      <IonToast
          isOpen={errorToast}
          onDidDismiss={() => setErrorToast(false) }
          message={errorToastMessage}
          duration={2000}
          color="danger"
          position="middle"
      />

      {propertySelectModal &&
      <IonModal isOpen>
        <IonHeader translucent>
          <IonToolbar>
            <IonTitle>Choose property</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={togglePropertySelectModal}>Close</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
          <IonList>
            {propertySearchResult.map(result =>
            <IonItem
              key={result.id}
              button={true}
              onClick={() => setProperty(result)}
              color={result.id === (property && property.id) ? 'primary' : 'light'}
            >
              <IonLabel>
                {result.tabspropref} - {result.name}
                <p>{result.address?.line1}, {result.address?.town}, {result.address?.postcode}</p>
              </IonLabel>
            </IonItem>
            )}
          </IonList>
          <IonButton
            expand="block"
            disabled={!property}
            onClick={togglePropertySelectModal}
          >
            OK
          </IonButton>
        </IonContent>
      </IonModal>
      }
    </IonPage>
  );

}
